import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/Top.vue'
import Select from '../views/Select.vue'
import Result from '../views/Result.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Top',
    component: Top
  },
  {
    path: '/select/:build',
    name: 'Select',
    component: Select,
    props:true
  },
  {
    path: '/result/:build',
    name: 'Result',
    component: Result,
    props:true
  }
]

const router = new VueRouter({
  mode: 'history',
  // eslint-disable-next-line no-unused-vars
  scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
